import React from 'react';
import { BackerTiles } from '../Icons';

const TEAM_PHOTOS = {
  dileep: '/screens/assets/images/Dileep.png',
  vinay: '/screens/assets/images/vinay.png',
} as const;

export function About() {
  return (
    <div className="s-wrap">
      <p className="s-eyebrow">About Tarana</p>
      <h1 className="s-h2" style={{ maxWidth: 720 }}>We're building the professional<br /><em>home for the music industry.</em></h1>

      <div className="about-grid">
        <div>
          <div className="about-mission">
            <p>India is one of the largest music audiences in the world, and its independent music scene is growing faster than ever. Yet the people who make that music have no professional infrastructure — discovery happens in DMs, hiring happens by word of mouth, and payment happens on trust.</p>
            <p>Tarana exists to change that. We're building the professional network and marketplace for the music industry — one place where artists, producers, composers, engineers, labels, studios, and production houses build credible profiles, get discovered, collaborate, and get paid for real work.</p>
            <p>We're starting with India, where the opportunity is largest and the infrastructure is most absent — and we're building it the way the industry actually works.</p>
          </div>

          <div style={{ marginTop: 48 }}>
            <p className="s-eyebrow">Meet the team</p>
            <div className="team-grid">
              <div className="team-card">
                <div className="team-avatar">
                  <img src={TEAM_PHOTOS.dileep} alt="Sangi Dileep Chakravarthi" className="team-avatar-img" />
                </div>
                <div className="team-name">Sangi Dileep<br />Chakravarthi</div>
                <div className="team-role">Founder &amp; CEO</div>
              </div>
              <div className="team-card">
                <div className="team-avatar">
                  <img src={TEAM_PHOTOS.vinay} alt="Chitturi Vinay  Manikanta" className="team-avatar-img" />
                </div>
                <div className="team-name">Chitturi Vinay <br />Manikanta</div>
                <div className="team-role">CTO</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <p className="s-eyebrow">Get in touch</p>
          <div className="contact-block">
            <div className="contact-row-group">
              <div className="contact-row"><span className="contact-label">General</span><a href="mailto:hey@taranamusic.in">hey@taranamusic.in</a></div>
              <div className="contact-row"><span className="contact-label">Support</span><a href="mailto:support@taranamusic.in">support@taranamusic.in</a></div>
            </div>
            <div className="contact-row"><span className="contact-label">Investors &amp; Partnerships</span><a href="mailto:invest@taranamusic.in">invest@taranamusic.in</a></div>
            <div className="contact-row" style={{ marginTop: 8 }}><span className="contact-label">Registered as</span>Tarana Media Private Limited · Hyderabad, India</div>
          </div>

          <div style={{ marginTop: 48 }}>
            <p className="s-eyebrow">Backed by</p>
            <div className="backer-logos"><BackerTiles /></div>
          </div>
        </div>
      </div>
    </div>
  );
}
